import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import mainbannerimage from "../../assets/Mainbanner/main.png";
import WorkerLogin from "../login/workerlogin";
import workericon from '../../assets/icons/worker.png'
const Workererchoose = () => {
  const { t, i18n } = useTranslation();
  return (
    <section
      className="opacity-0 py-[40px] flex justify-center items-center flex-col gap-6 animate-[showtitle_1s_forwards]"
      style={{
        backgroundImage: `url(${mainbannerimage})`,
      }}
    >
      <section className="w-full flex justify-center items-center flex-col gap-3">
       <span className="w-[80px] h-[80px] flex justify-center items-center rounded-full border-[2px] border-white">
         <img className="size-[70%] object-contain" src={workericon} alt="" />
       </span>
        <WorkerLogin />
      </section>
      <section className="w-full py-[30px] gap-3 px-0 flex justify-center items-center flex-col ">
       
        <h1
          className="text-[30px] max-lg:text-[40px] max-sm:text-[20px] opacity-0 text-center w-full animate-[showtitle_1s_forwards] font-black uppercase text-white"
          style={{
            animationDelay: ".2s",
          }}
        >
          {t("choosetitle")}
        </h1>
        
          <div
            className="w-[600px] h-[260px] max-sm:h-[320px] bg-white max-sm:w-full transition-all opacity-0 animate-[showtitle_1s_forwards] duration-500 hover:-translate-y-3 flex justify-start items-center flex-col gap-3 rounded-2xl shadow-2xl shadow-black border-[2px]
        border-[#006674]"
            style={{
              animationDelay: ".4s",
            }}
          >
            <h1
              className="font-bold tracking-widest bg-[#006674] py-3 rounded-t-xl
           text-white w-full text-center uppercase text-3xl max-sm:text-xl"
            >
               {t("register3")}
            </h1>
            <div className="p-3 flex justify-between h-full items-center flex-col gap-6">
              <p
                style={{ whiteSpace: "pre-line" }}
                className="text-[#006674] break-all text-center"
              >
              {window.innerWidth <= 640
                  ? t("workerdescriptionmobile")
                  : t("workerdescription")}
              </p>
              <Link
                className="bg-[#006674] w-full text-center py-2 px-3 text-white rounded-[30px] 
          transition-all duration-200 hover:bg-[#848484] capitalize"
                to="/workerregister"
              >
                {t("register")}
              </Link>
            </div>
          </div>
      </section>
    </section>
  );
};
export default Workererchoose;
